<template>
    <div class='verificationBox'>
        <div class="verificationBox-title">
            测评
        </div>
        <div class="verificationBox-top">
            <h4>温馨提示：</h4>
            <p>1、测评前需进行实名认证，请务必保证本人测评</p>
            <p>2、同一身份证号仅可测试一次，请谨慎作答</p>
        </div>
        <div class="verificationBox-content">
            <ul>
                <li>
                    <p><span>*</span>手机号码</p>
                    <van-field
                        v-model="phone"
                        center
                        clearable
                        :border="false"
                        @focus="inputFocus"
                        use-button-slot
                        placeholder="请填写手机号码"
                    />
                </li>
                <li class="authcodeInputWrapper">
                    <p><span>*</span>验&nbsp;证&nbsp;码</p>
                    <van-field
                        v-model="Verification"
                        class="VerificationStyle fl"
                        clearable
                        placeholder="请填写验证码"
                        :border="false"
                    />

                    <div class="getVerificationStyle fr" @click="postAccountGetAuthCode('phone')">
                        <!-- 验证码 -->
                        {{VerificationStatus}}
                    </div>

                    <div class="clear"></div>
                </li>
             </ul>
          <div class="verificationBox-content-btn" :class="phone==='' || Verification==='' ? 'verificationBox-content-btn-active':''">
              <van-button round type="info" @click="toRegist">开始实名认证</van-button>
          </div>
        </div>

    </div>
</template>

<script>
import md5 from "js-md5";
const isPhone = /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/;
export default {
    name:'cepverification',
    data () {
        return {
            phone:'',
            clientHeight: 0,
            Verification: null,
            Countdown1: 0,
            place: 'handset',
            isReal: false,
        };
    },
    computed: {
        /* eslint-disable */
        VerificationStatus () {
            if(this.place === 'handset'){
                if (this.Countdown1) {
                return `${this.Countdown1}s`
                } else {
                return '获取验证码'
                }
            }
        },
        /* eslint-disable no-new */
    },
    methods: {
         async postAccountLoginByAuthCode() {
            // this.$router.push({
            //     path: '/idcard'
            // })
            const data = {
                account: this.phone,
                authCode: this.Verification,
                appraisalId:this.$route.query.id
            };
            this.$store.state.distributionId &&
                (data.distributionId = this.$store.state.distributionId);
            await this.$api.usercenter
                .loginByAuthCodeMiaoShen({ data })
                .then(async res => {
                    if (res.code != 0) {
                        this.$notify(res.message);
                        return false;
                    }
                    if (res.data) {
                        localStorage.setItem("token", res.data);
                        // this.$textTip('登录成功')
                        await localStorage.setItem(
                            "WDuserInfo",
                            JSON.stringify(this.$store.state.userInfo)
                        );
                        // let that=this;
                        if(localStorage.getItem('token')){
                            setTimeout(()=>{
                                this.autoSelectOrganization();
                            },1000)
                        }
                        
                        
                    } else {
                        this.authCode.map(() => "");
                        return res.data;
                    }
                })
                .catch(() => {
                    this.$toast("验证码有误，请检查一下吧");
                    this.authCode.map(() => "");
                    return false;
                });
        },
        async autoSelectOrganization() {
             await this.$api.testreport.getmiaoFindUserBranchList({}).then(res => {
                if(res.data && res.data.length){
                    !localStorage.getItem('code') && localStorage.setItem('code', res.data[0].code)
                    !localStorage.getItem('organ') && localStorage.setItem('organ', res.data[0].organ)
                    !localStorage.getItem('actor') && localStorage.setItem('actor', res.data[0].actor)
                    !localStorage.getItem('branch') && localStorage.setItem('branch', res.data[0].branch)
                    !localStorage.getItem('channel') && res.data[0].channel && localStorage.setItem('channel', res.data[0].channel)
                    this.isRealNameAuthentication();
                }
            })
        },
        isRealNameAuthentication() {
            this.$api.exam.isRealNameAuthentication({}).then(data => {
                const userInfo = localStorage.getItem("token");
                this.isReal =
                    data.code === 0 &&
                    md5(userInfo + "true") === data.data;
                this.getAssessUrl(this.isReal);
                
                
            });
        },
        getAssessUrl(isReal){
            this.$api.testreport.getAssessUrl({}).then((res) => {
                let dataobj={};
                // const data='assessId=51&refId=51&refType=4';
                const data=res.data;
                const arraydata=String(data.split("&"))
                const arraydata1=String(arraydata.split("="))
                let arraydata2=arraydata1.split(",")
                for (let i =0;i<arraydata2.length;i++){
                    const key = arraydata2[i];
                    dataobj[key] = arraydata2[i+1];
                    i++;
                }
                if(!isReal){
                    this.$router.push({
                        path: '/idcard',
                        query: {
                            id: dataobj.assessId,
                            refId: dataobj.refId,
                            refType: dataobj.refType,
                            respondlink: 1,
                        }
                    })
                }else{
                    sessionStorage.setItem('countDownTime',new Date().getTime())
                    this.$router.push({
                        path: '/humanResting/respondPage',
                        query: {
                            id: dataobj.assessId,
                            refId: dataobj.refId,
                            refType: dataobj.refType,
                            respondlink: 1,
                        }
                    })
                }
                
            });
        },
        toRegist(){
            this.postAccountLoginByAuthCode();
        },
        postAccountGetAuthCode (type) {
            let CountdownType = type='Countdown1';
            if(this[CountdownType] > 0) return
            if (isPhone.test(this.phone)) {
                this.Countdown1 = 60
                this.setCountdown1()
                this.$sensors.track('UM_Click_Verification_Code_Button')
                this.getAuthCode()
            } else {
                let account = this.place === 'handset'? '手机号':'邮箱账号'
                this.$notify({ type: 'warning', message: account+ '格式有误,请检查一下吧' })
            }
        },
        getAuthCode(){
            const data = { phone: this.phone,appraisalId:this.$route.query.id}
            this.$api.usercenter.getAuthCodeMiaoShen({ data })

            // const data = { account: this.phone,type:2 }
            // if(this.theme === 'gongxin'){
            //     this.$api.usercenter.getAuthCodeCommon({ data })
            // }else {
            //     this.$api.usercenter.postAccountGetAuthCode({ data })
            // }  
        },
        setCountdown1 () {
            let Countdown = null
            Countdown = setInterval(() => {
                this.Countdown1--
                if (this.Countdown1 <= 0) {
                clearInterval(Countdown)
                }
            }, 1000)
        },
        
        
        inputFocus () {
            const height = document.documentElement.clientHeight
            if (this.clientHeight > height) {
                let vanField = document.querySelectorAll('.vanField')
                let total = vanField[0].offsetTop - 20
                document.documentElement.scrollTop = total
            } else {
                document.documentElement.scrollTop = 0
            }
            this.clientHeight = document.documentElement.clientHeight
        },
    },
    created(){
        localStorage.clear();
    }
}

</script>
<style lang='less' scoped>
.verificationBox{
    &-title{
        height: 2.133rem;
        line-height:2.133rem;
        text-align: center;
        border-bottom: 0.027rem solid #EBEDF2;
        font-size: 0.96rme;
        font-weight: 500;
        color: #31333A;
    }
    &-top{
        height: 5.12rem;
        background: #F7F7F7;
        border-radius: 0.213rem;
        margin: 0.64rem 0.8rem;
        padding: 0.8rem;
        box-sizing: border-box;
        h4{
            font-size: 0.693rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #3660FF;
            line-height: 0.693rem;
            margin-bottom: 0.693rem;
        }
        p{
            font-size: 0.693rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 1.066rem;
        }
    }
    &-content{
        padding:0 1.706rem;
        ul>li{
            height: 2.8rem;
            border-bottom:0.027rem solid #D7D7D7;
            display: flex;
            p{
                width: 5.2rem;
                font-size: 0.8rem;
                font-weight: 400;
                color: #333333;
                line-height: 2.666rem;
                span{
                    color: #F11D1D;
                    margin-right: 0.1333rem;
                }
            }
        }
        .van-cell{
            padding:0;
            height:2.8rem;
            line-height:2.8rem;
            font-size:0.8rem;
            background:transparent;
            padding-left: 0.3rem;
        }
        .getVerificationStyle{
            font-size: 0.64rem;
            margin-top: 0.533rem;
            font-weight: 400;
            color: #3860FF;
            min-width: 4.4rem;
            height: 1.546rem;
            border: 2px solid rgba(56, 96, 255, 1);
            border-radius:29px;

            text-align: center;
            line-height: 1.546rem;
            opacity: 0.7;
            margin-left: 0.2667rem;
            box-sizing: border-box;

        }
        .VerificationStyle{
            width:10.533rem;
        }
        
        .fl {
            float: left;
        }

        .fr {
            float: right;
        }
        &-btn{
            width: 100%;
            height: 2.346rem;
            background: linear-gradient(136deg, #407DF7 0%, #416DF6 100%);
            border-radius: 1.333rem;
            margin-top: 6.293rem;
            
            .van-button{
                width: 100%;
                height: 100%;
                font-size: 0.853rem;
                font-weight: 500;
            }
            .van-button--info{
                background-color: #1989fa;
                border: none;
                background: linear-gradient(136deg, #407DF7 0%, #416DF6 100%);
            }
        }
        &-btn-active{
            background: #CBCED5;
            .van-button--info{
                background-color: #1989fa;
                border: none;
                background: #CBCED5;
            }
        }
    }
}
</style>